import { takeEvery, call, put } from 'redux-saga/effects';
import { push, replace } from 'react-router-redux';
import { UserActions } from '../actions';
import axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { RouteUrls } from '../configs/routeUrls';
import Cookie from 'js-cookie';
import { DistrictDropdownOption } from '../utils/enums';

const userUrl = '/api/users';
const authUrl = '/api/auth';

export function* watchFetchUsers() {
	yield takeEvery(UserActions.FetchUsersAction.Request, fetchUsers);
}

function* fetchUsers(action) {
	try {
		let users = yield call(fetchUsersRequest, action.payload.page, action.payload.size);

		yield put({
			type: UserActions.FetchUsersAction.Success,
			payload: users
		});
	} catch (err) {
		yield put({
			type: UserActions.FetchUsersAction.Failure
		});
		toastr.error(
			'Błąd pobierania użytkowników',
			'Wystąpił niespodziewany błąd podczas pobierania listy użytkowników'
		);
	}
}

function fetchUsersRequest(page = 0, size = 20) {
	return axios.get(`${userUrl}?page=${page}&size=${size}`).then((response) => response.data).catch((err) => {
		throw err;
	});
}

export function* watchCreateUser() {
	yield takeEvery(UserActions.CreateUserAction.Request, createUser);
}
function* createUser(action) {
	try {
		yield call(createUserRequest, action.payload);
		yield put({
			type: UserActions.CreateUserAction.Success
		});
		toastr.success('Zapis', 'Tworzenie nowego użytkownika powiodło się');
		yield put(push(`${RouteUrls.User.list}`));
	} catch (err) {
		yield put({
			type: UserActions.CreateUserAction.Failure
		});
		toastr.error('Błąd tworzenia', 'Wystąpił niespodziewany problem podczas tworzenia nowego użytkownika');
	}
}
function createUserRequest(user) {
	return axios.post(`${userUrl}`, user).then((response) => response.data).catch((err) => {
		throw err;
	});
}

export function* watchFetchUser() {
	yield takeEvery(UserActions.FetchUserAction.Request, fetchUser);
}

function* fetchUser(action) {
	try {
		let user = yield call(fetchUserRequest, action.payload);

		yield put({
			type: UserActions.FetchUserAction.Success,
			payload: user
		});
	} catch (err) {
		yield put({
			type: UserActions.FetchUserAction.Failure
		});
		toastr.error('Błąd pobierania użytkownika', 'Wystąpił niespodziewany błąd podczas pobierania użytkownika');
	}
}

function fetchUserRequest(id) {
	return axios.get(`${userUrl}/${id}`).then((response) => response.data).catch((err) => {
		throw err;
	});
}

export function* watchUnloadUser() {
	yield takeEvery(UserActions.UnloadUserAction.Request, unloadUser);
}

function* unloadUser() {
	yield put({
		type: UserActions.UnloadUserAction.Success
	});
}

export function* watchUpdateUser() {
	yield takeEvery(UserActions.UpdateUserAction.Request, updateUser);
}

function* updateUser(action) {
	try {
		let user = yield call(updateUserRequest, action.payload);

		yield put({
			type: UserActions.UpdateUserAction.Success,
			payload: user
		});
		toastr.success('Aktualizacja użytkownika', 'Aktualizacja danych użytkownika zakończyła się powodzeniem');
		yield put(push(`${RouteUrls.User.list}`));
	} catch (err) {
		yield put({
			type: UserActions.UpdateUserAction.Failure
		});
		toastr.error(
			'Błąd aktualizacji użytkownika',
			'Wystąpił niespodziewany błąd podczas aktualizacji danych użytkownika'
		);
	}
}

function updateUserRequest(user) {
	return axios.put(`${userUrl}/${user.id}`, user).then((response) => response.data).catch((err) => {
		throw err;
	});
}

export function* watchLoginUser() {
	yield takeEvery(UserActions.LoginUserAction.Request, loginUser);
}

function* loginUser(action) {
	try {
		let loginResult = yield call(loginUserRequest, action.payload);
		yield put({
			type: UserActions.LoginUserAction.Success,
			payload: {
				isAuth: true,
				...loginResult
			}
		});
		yield put(replace(`${RouteUrls.App.main}`));
	} catch (ex) {
		toastr.error('Błąd logowania', 'Nieprawidłowe dane logowania');
		yield put({
			type: UserActions.LoginUserAction.Failure,
			payload: {
				isAuth: false,
				isAdmin: false,
				isSysAdmin: false,
				officePermissions: [],
				loginName: '',
				userId: null,
				officeId: null,
				districtId: DistrictDropdownOption.NotSetted,
				isCitizen: false,
				aswAccountId: null,
				aswMainProfileId: null
			}
		});
	}
}

function loginUserRequest(auth) {
	return axios.post(`${authUrl}/token`, auth).then((response) => response.data).catch((err) => {
		throw err;
	});
}

export function* watchInitialLoginUser() {
	yield takeEvery(UserActions.InitialLoginUserAction.Request, initialLoginUser);
}

function* initialLoginUser(action) {
	try {
		const loginResult = yield call(loginTokenRequest);
		yield put({
			type: UserActions.InitialLoginUserAction.Success,
			payload: {
				isAuth: true,
				...loginResult
			}
		});
	} catch (ex) {
		yield put({
			type: UserActions.InitialLoginUserAction.Failure,
			payload: {
				isAuth: false,
				isAdmin: false,
				isSysAdmin: false,
				officePermissions: [],
				loginName: '',
				userId: null,
				officeId: null,
				districtId: DistrictDropdownOption.NotSetted,
				isCitizen: false,
				aswAccountId: null,
				aswMainProfileId: null
			}
		});
	}
}

function loginByCookiesRequest() {
	return axios.get(`${authUrl}/login-cookies`).then((response) => response.data).catch((err) => {
		throw err;
	});
}

function loginTokenRequest() {
	return axios
		.get(authUrl)
		.then((response) => response.data)
		.catch((err) => {
			throw err;
		});
}

export function* watchLogoutUser() {
	yield takeEvery(UserActions.LogoutUserAction.Request, logoutUser);
}

function* logoutUser() {
	const urlParts = window.location.hostname.split('.');
	if (Cookie.get('at') && urlParts.length >= 2) {
		for (let i = 0; i <= urlParts.length - 2; i++) {
			Cookie.set('at', Cookie.get('at'), {
				path: '/',
				domain: urlParts.slice(i).join('.'),
				expires: -1
			});
		}
	}
	if (Cookie.get('rt') && urlParts.length >= 2) {
		for (let j = 0; j <= urlParts.length - 2; j++) {
			Cookie.set('rt', Cookie.get('rt'), {
				path: '/',
				domain: urlParts.slice(j).join('.'),
				expires: -1
			});
		}
	}
	yield put({
		type: UserActions.LogoutUserAction.Success
	});
	yield put(replace(`${RouteUrls.App.main}`));
}
